import branchStore from "./branch/store";
import employeeStore from "./employee/store";
import departmentStore from "./department/store";
import teamStore from "./team/store";
import settingsStore from "./settings/store";
import reportStore from "./reports/store";

export default {
  namespaced: true,
  modules: {
    branch: branchStore,
    employee: employeeStore,
    department: departmentStore,
    team: teamStore,
    settings: settingsStore,
    reports: reportStore,
  },
};
